import GenericServiceDetails from "./GenericServiceDetails";

export default GenericServiceDetails;
